'use client';
import { createContext } from 'react';

import type { GTMParamsManager } from '../manager';

export const GTMContext = createContext<GTMParamsManager | null>(null);
